export const getSavedEditedAmountsPayload = info => {
  const payload = {
    refund_method: info.refundMethodSelected,
    note: info.note,
  }

  info?.transactionConcepts?.forEach(concept => {
    payload[concept.concept] = concept.selected
  })

  return payload
}
